export default __webpack_public_path__ + "static/media/Video_thumbnail.20851f9c.jpg";